module.exports = __webpack_public_path__ + "img/P150T_weapon_3.e4cab5fd.png";